import React, { PureComponent, Fragment } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'react-css-modules'
import cn from 'classnames'
import makeUniqueId from 'helpers/makeUniqueId'
import { CSSTransition } from 'react-transition-group'

import isTouch from 'helpers/isTouch'
import { EnlargeIcon, SelectedIcon } from 'components/icon'

import styles from './grid_tile.scss'

import Bodymovin from 'components/bodymovin/bodymovin'
import correct from 'animations/matching_pairs/correct'
import incorrect from 'animations/matching_pairs/incorrect'

const correct_animation = JSON.parse(JSON.stringify(correct))
const incorrect_animation = JSON.parse(JSON.stringify(incorrect))

class GridTile extends PureComponent {

	constructor(props) {
		super(props)
		this.zoomClickHandler = this.zoomClickHandler.bind(this)
		this.tileClickHandler = this.tileClickHandler.bind(this)
		this.tileLoadedHandler = this.tileLoadedHandler.bind(this)
		this.state = {
			active: false,
			loaded: false,
		}
	}

	activate() {
		this.setState({
			active: true,
		})
	}

	zoomClickHandler(e) {
		e.stopPropagation()
		this.props.zoomClickHandler(this.props.index)
	}

	tileClickHandler() {
		this.props.tileClickHandler(this.props.index)
	}

	tileLoadedHandler() {
		if (!this.state.loaded) {
			this.setState({
				loaded: true,
			})
			this.props.tileLoadedHandler()
		}
	}

	componentDidMount() {
		this.randomRequestQuery = '?rnd=' + makeUniqueId()
		const isImage = this.props.content.display.type === 'image'
		if (!isImage) {
			this.tileLoadedHandler()
		}
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.content.status === 'error' && this.props.content.status !== 'error') {
			this.randomRequestQuery = '?rnd=' + makeUniqueId()
		} else if (
			nextProps.content.status === 'success' &&
		(this.props.content.status !== 'success' && this.props.content.status !== 'matched')) {
			this.randomRequestQuery = '?rnd=' + makeUniqueId()
		} else if (
			nextProps.content.status === 'matched' &&
		(this.props.content.status !== 'success' && this.props.content.status !== 'matched')) {
			this.randomRequestQuery = '?rnd=' + makeUniqueId()
		}
	}


	componentDidUpdate(prevProps) {
		if (prevProps.activate !== this.props.activate) {
			setTimeout(() => this.activate(), this.props.should_animate_card ? this.props.index * 50 : 0)
		}
	}

	render() {
		const isImage = this.props.content.display.type === 'image'

		const status = this.props.content.status
		let current_animation
		switch (status) {
			case 'success':
			case 'matched':
				current_animation = correct_animation
				break
			case 'error':
				current_animation = incorrect_animation
				break
		}
		return (
			<Fragment>
				<CSSTransition
					in={(this.state.active || !this.props.should_animate_card)}
					classNames={{
						enter: styles['enter-start'],
						enterActive: styles['enter-start-active'],
						exit: styles['exit-start'],
						exitActive: styles['exit-start-active'],
					}}
					timeout={{enter: 1000, exit: 10}}
					unmountOnExit
				>
					<Fragment>
						{(this.state.active || !this.props.should_animate_card) &&
					<div
						styleName={
							cn({
								wrapper: true,
								animated: this.props.should_animate_card,
							})
						}
						style={{width: this.props.card_width, height: this.props.card_height, fontSize: this.props.font_size}}
						ref={el => this.element=el}
					>
						<div styleName={
							cn({
								Tile: true,
								'Tile--selected': this.props.content.status === 'selected',
								'Tile--success': this.props.content.status === 'success',
								'Tile--matched': this.props.content.status === 'matched',
								'Tile--error': this.props.content.status === 'error',
							})}
						onClick={this.tileClickHandler}
						>
							<div styleName="checked"><SelectedIcon /></div>
							{
								this.props.content.status !== 'success' &&
								this.props.content.status !== 'matched' &&
									<div styleName={cn({
										zoom: true,
										'zoom-touch-enabled': isTouch(),
									})}
									onClick={this.zoomClickHandler}>
										<EnlargeIcon />
									</div>
							}
							{isImage && <img styleName="image" onLoad={this.tileLoadedHandler} src={this.props.content.display.value} />}
							{!isImage && (
								<div styleName='Tile-text-wrapper'>
									<span
										styleName={
											cn({
												'Tile-text': true,
												'Tile-text--small': false,
											})
										}
									>
										{this.props.content.display.value}
									</span>
								</div>
							)}
							{(
								this.props.content.status === 'error' ||
								this.props.content.status === 'success' ||
								this.props.content.status === 'matched'
							) &&
								<Bodymovin animationData={current_animation} loop={false} autoplay={true} >
									<div style={{width: '100%', height: '100%', position: 'absolute', top: 0, left: 0}}></div>
								</Bodymovin>
							}
							{/*
								<Isvg styleName="success-error-animation" src={animation_path} cacheGetRequests={true} />
							*/}
						</div>
					</div>}
					</Fragment>
				</CSSTransition>
				{isImage && this.props.should_animate_card && <img src={this.props.content.display.value} onLoad={this.tileLoadedHandler} style={{width: 0, height: 0, position: 'absolute'}}/>}
			</Fragment>
		)
	}
}

GridTile.propTypes = {
	selected: PropTypes.bool,
	matched: PropTypes.bool,
	content: PropTypes.object,
	showHelpTooltip: PropTypes.bool,
	tileClickHandler: PropTypes.func,
	tileLoadedHandler: PropTypes.func,
	font_size: PropTypes.string,
}

GridTile.defaultProps = {
	selected: false,
	matched: false,
	content: {},
	showHelpTooltip: false,
	tileClickHandler: () => { },
	tileLoadedHandler: () => { },
	font_size: '0px',
}

export default CSSModules(GridTile, styles, { allowMultiple: true })
